import { NetworkFilters } from "../../../components/filters/models/networkFilters";

export interface INetwork {
  brands: string[],
  regions: string[],
  subregions: string[],
  markets: string[],
  dealers: string[],
  outlets: string[],
  areaSales: string[],
  subareaSales: string[],
  areaAfterSales: string[],
  subareaAfterSales: string[],
}

export class Network implements INetwork {
  brands: string[] = [];
  regions: string[] = [];
  subregions: string[] = [];
  markets: string[] = [];
  dealers: string[] = [];
  outlets: string[] = [];
  areaSales: string[] = [];
  subareaSales: string[] = [];
  areaAfterSales: string[] = [];
  subareaAfterSales: string[] = [];

  constructor(filters?: Partial<NetworkFilters>) {
    if(filters) {
      this.brands = filters?.brands ?? [];
      this.regions = filters?.regions ?? [];
      this.subregions = filters?.subregions ?? [];
      this.markets = filters?.markets ?? [];
      this.dealers = filters?.dealers ?? [];
      this.outlets = filters?.outlets ?? [];
      this.areaSales = filters?.areaSales ?? [];
      this.subareaSales = filters?.subareaSales ?? [];
      this.areaAfterSales = filters?.areaAfterSales ?? [];
      this.subareaAfterSales = filters?.subareaAfterSales ?? [];
    }
  }
}
